var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('waybill-create-r-x-real',{attrs:{"waybillSplitId":_vm.waybillSplitId,"isSee":_vm.isSee,"type":_vm.type,"commandIds":_vm.commandIds},on:{"reset":_vm.reset}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }